import { Fragment, memo, ReactElement } from 'react';
import { Form, Formik } from 'formik';
import { ResearchAct } from 'civil-status/view-models/research-category-form';
import * as yup from 'yup';
import { DateTime } from 'luxon';
import { Accordion, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails } from '@mui/material';
import FormFilter from './form';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  FilterResearchNotificationsSide,
  FilterResearchNotificationsSideFlags,
} from 'civil-status/view-models/notifications-list-side';
import { ItemVM } from 'shell/view-models/item';
import { TypeSearchOperator } from 'civil-status/constants/type-search-operator';

const validationSchema = yup
  .object({
    dateStart: yup.date().nullable().typeError('Data non valida'),
    dateEnd: yup
      .date()
      .nullable()
      .typeError('Data non valida')
      .when('dateStart', (dateStart, formvalidationSchema) =>
        dateStart && dateStart?.toString() !== 'Invalid Date'
          ? formvalidationSchema.min(
              dateStart,
              'La data deve essere maggiore o uguale della Data inizio'
            )
          : formvalidationSchema.nullable()
      ),
  })
  .test('dateEnd', 'Campo obbligatorio', (values) => {
    const valuesCasted = (values || {}) as unknown as ResearchAct;

    if (
      valuesCasted.dateEnd &&
      valuesCasted.dateEnd?.toString() !== 'Invalid Date' &&
      valuesCasted.dateStart &&
      valuesCasted.dateStart?.toString() !== 'Invalid Date'
    ) {
      const dateStart = DateTime.fromISO(valuesCasted.dateStart as unknown as string);
      const dateEnd = DateTime.fromISO(valuesCasted.dateEnd as unknown as string);

      // se abbiamo entrambe le date effettuare controllo
      if (dateStart.plus({ month: 1 }) > dateEnd) {
        // range massimo un mese
        return new yup.ValidationError(
          'La data può essere maggiore al massimo di un mese',
          undefined,
          'dateEnd'
        );
      }
      return true;
    }

    return true;
  });

interface AccordionFilterNotificationsProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
  handleSubmitResearchNotifications: (values: FilterResearchNotificationsSide) => void;
  idCat?: string;
  initialValues?: FilterResearchNotificationsSide;
  visibleFilters?: FilterResearchNotificationsSideFlags;
  filterKindNotification?: (items: ItemVM[]) => ItemVM[];
}

const AccordionFilterNotificationsComponent = ({
  open,
  setOpen,
  handleSubmitResearchNotifications,
  idCat,
  initialValues,
  visibleFilters,
  filterKindNotification,
}: AccordionFilterNotificationsProps): ReactElement => {
  return (
    <Fragment>
      <Formik
        key="form-filter"
        initialValues={
          initialValues ||
          ({
            codOperator: '',
            dateEnd: null,
            dateStart: null,
            idAnscNotification: '',
            idEventNotification: '',
            kindNotification: null,
            owners: '',
            register: null,
            stateNotification: null,
            typeContentNotification: null,
            hasSearchOperatore: TypeSearchOperator.NessunFiltroOperatore,
          } as FilterResearchNotificationsSide)
        }
        onSubmit={(values) => handleSubmitResearchNotifications(values)}
        validateOnMount
        validationSchema={validationSchema}
      >
        <Form>
          <Accordion
            expanded={open}
            onChange={() => {
              setOpen(!open);
            }}
          >
            <AccordionSummary
              aria-controls="filter-notifications-content"
              id="panel-filter-notifications-header"
              classes={{
                root: 'pmi-flex-row-reverse',
              }}
              expandIcon={<ExpandMore />}
            >
              <Typography>Filtri di ricerca</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FormFilter
                idCat={idCat}
                formFilterVisible={visibleFilters}
                filterKindNotification={filterKindNotification}
              />
            </AccordionDetails>
          </Accordion>
        </Form>
      </Formik>
    </Fragment>
  );
};

AccordionFilterNotificationsComponent.displayName =
  'Research notifications - Filters component - AccordionFilterNotifications';

const AccordionFilterNotifications = memo(AccordionFilterNotificationsComponent);

export default AccordionFilterNotifications;
